import { connect } from 'react-redux';
import View from './MonteCarloChartView';
import {
  chartsData,
  loadingSelector,
  responseDataSelector,
  requestedWithSelector,
  stagedWhatIfsSelector,
  errorSelector,
} from './MonteCarloChartSelector';
import {
  fetchMcData,
  fetchPostMcData,
  setUpdateCacheData,
  abortMcRequests,
} from './MonteCarloChartActions';
import {
  makePercentageOfSuccess,
  makeMonteCarloSuccessRange,
} from '../FinancialPlan/FinancialPlanHelpers';
import {
  selectPrincipalAge,
  selectSpouseAge,
} from '../WhatIfs/Retirement/SocialSecurity/MonthlyBenefitsSelector';

const mapStateToProps = (state, ownProps) => {
  const data = responseDataSelector(state, ownProps) || {};
  let whatIfsProps = {};
  if (!ownProps.isPdf) {
    whatIfsProps = {
      stagedWhatIfs: stagedWhatIfsSelector(state, ownProps),
    };
  }

  const principalAge = selectPrincipalAge(state, ownProps);
  const spouseAge = selectSpouseAge(state, ownProps);

  const FRAOption = {
    ...(principalAge === 'FRA'
      ? { UseFraPrincipal: true, SocialSecurityStartAgePrincipal: 0 }
      : { UseFraPrincipal: null }),
    ...(spouseAge === 'FRA'
      ? { UseFraSpouse: true, SocialSecurityStartAgeSpouse: 0 }
      : { UseFraSpouse: null }),
  };
  return {
    ...whatIfsProps,
    chartsData: chartsData(state, ownProps),
    loading: loadingSelector(state, ownProps),
    error: errorSelector(state, ownProps),
    trialsCount: data.MonteCarloTrialsCount || '',
    monteCarloSuccessRange: makeMonteCarloSuccessRange(data.MonteCarloSuccessRange),
    percentageOfSuccess: makePercentageOfSuccess(data.ProbabilityOfSuccess),
    requestedWith: requestedWithSelector(state, ownProps),
    FRAOption,
  };
};

const mapDispatchToProps = dispatch => ({
  fetchMcData: (fpId, clientId) => {
    dispatch(fetchMcData(fpId, clientId));
  },
  fetchPostMcData: (fpId, clientId, isPdf, whatIfArrayOrSingle, FRAOption) => {
    dispatch(fetchPostMcData(fpId, clientId, isPdf, whatIfArrayOrSingle, FRAOption));
  },
  setUpdateCacheData: (clientId, updateCacheData) => {
    dispatch(setUpdateCacheData(clientId, updateCacheData));
  },
  abortMcRequests: () => {
    dispatch(abortMcRequests());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
